import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginAdmin(loginPayload: { email: $email, password: $password }) {
      accessToken
      tokenExpiresIn
      userType
      profile {
        _id
        uuid
        firstName
        lastName
        email
        phone

        activityStatus
        createdAt
        updatedAt
        country {
          name
          alias
        }
      }
    }
  }
`;

export const CREATE_PRODUCT_CATEGORIES = gql`
  mutation createCategory(
    $name: String!
    $imageUrl: String!
    $isActive: Boolean!
    $description: String
  ) {
    createCategory(
      payload: {
        name: $name
        imageUrl: $imageUrl
        isForService: false
        isActive: $isActive
        description: $description
      }
    ) {
      createdAt
      updatedAt
      _id
      name
      image
      description
      isActive
      isForService
    }
  }
`;

export const DELETE_CATEGORIES = gql`
  mutation deleteCategory($categoryId: String!) {
    deleteCategory(payload: { categoryId: $categoryId }) {
      message
    }
  }
`;

export const APPROVE_PRODUCT = gql`
  mutation approveProduct($productId: String!) {
    approveProduct(payload: { productId: $productId })
  }
`;

export const REJECT_PRODUCT = gql`
  mutation rejectProduct($productId: String!, $reasonForRejection: String!) {
    rejectProduct(
      payload: {
        productId: $productId
        reasonForRejection: $reasonForRejection
      }
    )
  }
`;
export const DELETE_PRODUCT = gql`
  mutation deleteProduct($productId: String!) {
    deleteProduct(payload: { productId: $productId })
  }
`;

export const EDIT_PROFILE = gql`
  mutation updateAdminProfile($firstName: String!, $lastName: String!) {
    updateAdminProfile(
      payload: { firstName: $firstName, lastName: $lastName }
    ) {
      _id
      uuid
      firstName
      lastName
      email
      phone
      activityStatus
      createdAt
      updatedAt
      country {
        name
        alias
      }
    }
  }
`;

export const CREATE_ROLE = gql`
  mutation CreateAdminRole($title: String!, $permissionIds: [String!]!) {
    createAdminRole(
      payload: { title: $title, description: "", permissionIds: $permissionIds }
    ) {
      createdAt
      updatedAt
      _id
      title
      description
    }
  }
`;

export const CREATE_TEAM = gql`
  mutation createAdminProfile(
    $firstName: String!
    $lastName: String!
    $role: String!
    $email: String!
    $password: String!
    $accessType: String!
  ) {
    createAdminProfile(
      payload: {
        firstName: $firstName
        lastName: $lastName
        role: $role
        email: $email
        phone: null
        password: $password
        accessType: $accessType
      }
    ) {
      _id
      firstName
      lastName
      email
      role {
        title
      }
    }
  }
`;

export const UPDATE_TEAM_ROLE = gql`
  mutation UpdateAdminRole($role: String!) {
    updateAdminRole(payload: { role: $role }) {
      createdAt
      updatedAt
      _id
      uuid
      firstName
      lastName
      imageUrl
      email
      phone
      sex
      accessType
      verifiedAt
      activityStatus
    }
  }
`;

export const DEACTIVATE_TEAM = gql`
  mutation DeactivateAdminProfile($userId: String!) {
    deactivateAdminProfile(payload: { userId: $userId }) {
      message
    }
  }
`;

export const CREATE_BANNER = gql`
  mutation createBanner(
    $imageUrl: String!
    $type: String!
    $route: String!
    $description: String!
  ) {
    createBanner(
      payload: {
        imageUrl: $imageUrl
        type: $type
        route: $route
        description: $description
      }
    ) {
      createdAt
      updatedAt
      _id
      type
      imageUrl
      description
      route
    }
  }
`;

export const CREATE_BLOG = gql`
  mutation createBlog(
    $title: String!
    $slug: String!
    $imageUrl: String!
    $content: String!
    $category: String!
    $status: String!
     $description: String!
  ) {
    createBlog(
      payload: {
        title: $title
        slug: $slug
        imageUrl: $imageUrl
        content: $content
        category: $category
        status: $status
        description: $description
      }
    ) {
      createdAt
      updatedAt
      _id
      title
      slug
      imageUrl
      content
      category
      status
      isDeleted
    }
  }
`;

export const UPDATE_BLOG = gql`
  mutation UpdateBlog(
    $blogId: String!
    $title: String!
    $slug: String!
    $imageUrl: String!
    $content: String!
    $category: String!
    $status: String!
    $description: String!
  ) {
    updateBlog(
      payload: {
        blogId: $blogId
        title: $title
        slug: $slug
        imageUrl: $imageUrl
        content: $content
        category: $category
        status: $status
        description: $description
      }
    ) {
      createdAt
      updatedAt
      _id
      title
      slug
      imageUrl
      content
      category
      status
      isDeleted
    }
  }
`;

export const DELETE_BLOG = gql`
  mutation DeleteBlog($blogId: String!) {
    deleteBlog(payload: { blogId: $blogId })
  }
`;

export const DEACTIVATE_USER = gql`
  mutation deactivate($userId: String!) {
    blockOrUnblockUser(payload: { userId: $userId }) {
      _id
      activityStatus
    }
  }
`;

export const DELETE_BANNER = gql`
  mutation delete($bannerId: String!) {
    deleteBanner(payload: { bannerId: $bannerId }) {
      message
    }
  }
`;

export const CREATE_NOTIFICATION = gql`
  mutation CreatePushNotificationForAccount(
    $account: String!
    $title: String!
    $message: String!
    $state: String
    $city: String
  ) {
    createPushNotificationForAccount(
      payload: {
        account: $account
        title: $title
        message: $message
        state: $state
        city: $city
      }
    ) {
      message
    }
  }
`;

export const CREATE_NOTIFICATION_USER = gql`
  mutation SendPushNotificationToUser(
    $title: String!
    $message: String!
    $email: String!
  ) {
    sendPushNotificationToUser(
      payload: { title: $title, message: $message, email: $email }
    ) {
      message
    }
  }
`;

export const EDIT_SUB_CATEGORY = gql`
  mutation editSub($subCategoryId: String!, $name: String!) {
    editSubCategory(
      payload: {
        subCategoryId: $subCategoryId
        name: $name
        # category: "",
        # description: "",
        # isActive: false
      }
    ) {
      _id
      name
    }
  }
`;

export const EDIT_CATEGORY = gql`
  mutation editCategory(
    $categoryId: String!
    $name: String
    $description: String
    $isActive: Boolean
    $isForService: Boolean
    $imageUrl: String
  ) {
    editCategory(
      payload: {
        categoryId: $categoryId
        name: $name
        description: $description
        isActive: $isActive
        isForService: $isForService
        imageUrl: $imageUrl
      }
    ) {
      createdAt
      updatedAt
      _id
      name
      image
      description
      isActive
      isForService
    }
  }
`;

export const DELETE_SUB_CATEGORY = gql`
  mutation deleteSub($subCategoryId: String!) {
    deleteSubCategory(payload: { subCategoryId: $subCategoryId }) {
      message
    }
  }
`;

export const CREATE_SUB_CATEGORY = gql`
  mutation createSub($name: String!, $category: String!) {
    createSubCategory(
      payload: {
        name: $name
        category: $category
        description: ""
        isActive: true
      }
    ) {
      _id
      name
    }
  }
`;

export const REFUND_BUYER = gql`
  mutation refund($itemId: String!) {
    refundToCustomer(payload: { itemId: $itemId }) {
      message
    }
  }
`;

export const RELEASE_FUND = gql`
  mutation release($itemId: String!) {
    handleAdminReleaseFundsProcess(payload: { itemId: $itemId }) {
      message
    }
  }
`;

export const REFUND_CUSTOMER_ORDER = gql`
  mutation refund($itemId: String!) {
    refundToCustomer(payload: { itemId: $itemId }) {
      message
    }
  }
`;

export const APPROVE_PAYMENT_REQUEST = gql`
  mutation approve($withdrawalRequestId: String!) {
    approvePendingWithdrawal(withdrawalRequestId: $withdrawalRequestId) {
      _id
      reference
      amount
      remarks
      status
      updatedAt
      currency
      user {
        firstName
        lastName
      }
    }
  }
`;

export const DECLINE_PAYMENT_REQUEST = gql`
  mutation reject($withdrawalRequestId: String!) {
    rejectPendingWithdrawal(withdrawalRequestId: $withdrawalRequestId) {
      _id
      reference
      amount
      remarks
      status
      updatedAt
      currency
      user {
        firstName
        lastName
      }
    }
  }
`;

export const EDIT_CHARGES_CONFIG = gql`
  mutation EditChargeConfig(
    $name: String!
    $chargeConfigId: String!
    $isActive: Boolean!
    $chargeType: String!
    $chargeValue: Float!
    $currencyId: String!
    $description: String!
  ) {
    editChargeConfig(
      payload: {
        name: $name
        chargeConfigId: $chargeConfigId
        isActive: $isActive
        chargeType: $chargeType
        chargeValue: $chargeValue
        currencyId: $currencyId
        description: $description
      }
    )
  }
`;

export const ADMIN_EDIT_PRODUCT = gql`
  mutation AdminEditProduct(
    $productId: String!
    $country: String!
    $name: String!
    $description: String!
    $isNegotiable: Boolean!
    $price: Float!
    $weight: Float
    $categories: [String!]!
    $images: [String!]!
  ) {
    adminEditProduct(
      payload: {
        productId: $productId
        country: $country
        name: $name
        description: $description
        isNegotiable: $isNegotiable
        price: $price
        weight: $weight
        categories: $categories
        images: $images
      }
    )
  }
`;
